import React, { useState } from "react";
import { Select, Space } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
// import "../../styles.css"
const customTheme = {
  token: {
    colorPrimary: "#00b96b",
    borderRadius: 2,
    colorBgContainer: "#f6ffed",
    borderColor: "#CCCCCC", // Setting default border color
    hoverBorderColor: "#CCCCCC", // Setting hover border color
  },
  components: {
    Select: {
      base: {
        "&:hover .ant-select-selector": {
          borderColor: "var(--antd-border-hover-color)", // Reference hoverBorderColor
        },
      },
    },
  },
};

export default function SelectBox({
  label,
  options,
  error,
  onChange,
  touched,
  name,
  width,
  defaultValue,
  reqiured,
  ...props
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSelectFocused, setIsSelectFocused] = useState(false);

  const handleSelectChange = (value) => {
    const event = {
      target: {
        name: name,
        value: value,
      },
    };
    onChange(event);
  };
  const handleSuffixIconClick = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSelectFocus = () => {
    setIsSelectFocused(true);
    setIsExpanded(true);
  };

  const handleSelectBlur = () => {
    setIsSelectFocused(false);
    setIsExpanded(false);
  };

  return (
    <div
      className={`${
        props.componentWidth
          ? props?.componentWidth
          : "flex flex-col md:mt-2 border-red w-full"
      } `}
    >
      {label && (
        <label className="py-2 text-sm text-gray-600 font-medium">
          {label}
           {reqiured && <span className="text-red ml-1 text-base">*</span>}
        </label>
      )}
      <div
        className={`${
          touched && error ? "border border-red" : "border border-[#CCCCCC]"
        } rounded-md bg-white`}
      >
        <Select
          {...props}
          defaultValue={defaultValue}
          className={`custom-scrollbar h-[2.42rem] w-full ${
            width ? width : "min-w-[9.5rem]"
          }  text-sm text-body !border-[#CCCCCC]  !text-[#aeaeae] ${
            touched && error ? "border-red" : "" // Apply red border only when not focused
          }`}
          onChange={handleSelectChange}
          onFocus={handleSelectFocus}
          onBlur={handleSelectBlur}
          options={options.map((item) => ({
            value: item.value,
            label: item.label,
          }))}
          variant="borderless"
          suffixIcon={<CaretDownOutlined onClick={handleSuffixIconClick} />}
          onClick={handleSuffixIconClick}
          open={isExpanded} // Set the open prop to the isExpanded state
        />
      </div>
    </div>
  );
}

export function MultiSelectBox({
  tipData,
  label,
  options,
  error,
  onChange,
  touched,
  name,
  width = 0,
  defaultValue,
  ...props
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSelectFocused, setIsSelectFocused] = useState(false);

  const handleSelectChange = (value) => {
    const event = {
      target: {
        name: name,
        value: value,
      },
    };
    onChange(event);
  };
  const handleSuffixIconClick = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSelectFocus = () => {
    setIsSelectFocused(true);
    setIsExpanded(true);
  };

  const handleSelectBlur = () => {
    setIsSelectFocused(false);
    setIsExpanded(false);
  };

  return (
    <div
      className={`${
        props.componentWidth
          ? props?.componentWidth
          : "flex flex-col md:mt-2 border-red w-full"
      } `}
    >
      {label && (
        <div className="flex">
          <label className="py-2 text-sm text-gray-600 font-medium me-3">
            {label}
          </label>
          {tipData && (
            <Tooltip className=" mb-1" title={tipData} trigger="click">
              <InfoCircleOutlined className="cursor-pointer text-blue-500" />
            </Tooltip>
          )}
        </div>
      )}
      <div
        className={`${
          touched && error ? "border border-red" : "border border-[#CCCCCC]"
        } rounded-md bg-white`}
      >
        <Space style={{ width: "100%" }} direction="vertical">
          <Select
            mode="multiple"
            allowClear
            showSearch
            optionFilterProp="label"
            {...props}
            defaultValue={defaultValue}
            // style={{width:'100%'}}
            className={`custom-scrollbar w-full ${
              width != 0 ? width : "min-w-[9.5rem]"
            }  text-sm text-body !border-[#CCCCCC]  !text-[#aeaeae] ${
              touched && error ? "border-red" : "" // Apply red border only when not focused
            }`}
            onChange={handleSelectChange}
            onFocus={handleSelectFocus}
            onBlur={handleSelectBlur}
            options={options.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
            variant="borderless"
            suffixIcon={<CaretDownOutlined onClick={handleSuffixIconClick} />}
          />
        </Space>
      </div>
    </div>
  );
}
